import './App.css';


// Components 
import Calcuator from "./components/calculator";

function App() {
  return (
    <div className="container">
      <Calcuator />
    </div>
  );
}

export default App;
